import dayjs from 'dayjs';
import _ from 'lodash';

export function objectTransenum<T extends { [key: string]: string }>(object: T) {
    if (!object) {
        return []
    }
    return Object.keys(object).map(key => ({ name: object[key], value: key }))
}

export function disabledBetweenDate({ isStart, startKey, endKey }, formData) {
    let start = _.get(formData, startKey);
    let end = _.get(formData, endKey);

    if (!isStart && start) {
        return {
            disabledDate: (current) => {
                return current && current.isBefore(dayjs(start))
            }
        }
    }
    if (isStart && end) {
        return {
            disabledDate: (current) => {
                return current && current.isAfter(dayjs(end))
            }
        }
    }

    return {};
}


// 金额转数字
export function budgetToNumber(budget?: string | number) {
    if (typeof budget === 'number') {
        return budget
    }
    // undefined, null, ''
    if (!budget) return '';
    return Number(budget.replace(/[^0-9.]/g, ''))
}
